export enum QualityIssueType {
    COUNTRY_LABEL_ISSUE = 'Country Label Issue',
    PRODUCT_LABEL = 'Product Label'
}
